class Logger {
    dateFormat(date) {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        const hour = `${date.getHours()}`.padStart(2, '0');
        const minute = `${date.getMinutes()}`.padStart(2, '0');
        const second = `${date.getSeconds()}`.padStart(2, '0');
        return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    }
    write(level, msg) {
        if (!this.use) {
            const formattedMsg = `[${this.dateFormat(new Date())}] [${level}] [Workbench] - ${msg}`;
            switch (level) {
                case 'FATAL':
                case 'ERROR':
                    console.error(formattedMsg);
                    break;
                case 'WARN':
                    console.warn(formattedMsg);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log(formattedMsg);
                    break;
            }
        }
    }
    debug(msg) {
        var _a;
        (_a = this.use) === null || _a === void 0 ? void 0 : _a.debug(msg);
        this.write('DEBUG', msg);
    }
    info(msg) {
        var _a;
        (_a = this.use) === null || _a === void 0 ? void 0 : _a.info(msg);
        this.write('INFO', msg);
    }
    warn(msg) {
        var _a;
        (_a = this.use) === null || _a === void 0 ? void 0 : _a.warn(msg);
        this.write('WARN', msg);
    }
    error(msg) {
        var _a;
        (_a = this.use) === null || _a === void 0 ? void 0 : _a.error(msg);
        this.write('ERROR', msg);
    }
    fatal(msg) {
        var _a;
        (_a = this.use) === null || _a === void 0 ? void 0 : _a.fatal(msg);
        this.write('FATAL', msg);
    }
}
const $logger = new Logger();

export { $logger, Logger };
//# sourceMappingURL=logger.js.map
